var _path, _rect, _rect2, _path2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 158,
    viewBox: "0 0 160 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M40.0293 25.6822C40.0293 25.6822 64.1171 43.961 100.737 9.78265C133.259 -20.571 159.813 27.3202 159.999 50.2543C160.24 79.9635 127.477 103.734 143.376 123.248C159.276 142.761 111.845 174.984 86.2825 147.097C54.4834 112.407 45.8684 140.593 27.7433 140.593C14.7345 140.593 -11.9738 108.269 6.06208 84.2216C21.2389 63.9857 12.962 57.2698 8.95283 50.2543C3.17123 40.1364 16.9027 12.6735 40.0293 25.6822Z",
    fill: "#26303E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.9711,
    y: 51.2136,
    width: 48.3497,
    height: 67.9301,
    rx: 7,
    transform: "rotate(2.5 65.9711 51.2136)",
    fill: "#EEEEEE",
    stroke: "#999999",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2491,
    y: 46.5414,
    width: 52.3497,
    height: 71.9301,
    rx: 9,
    transform: "rotate(-7.5 36.2491 46.5414)",
    fill: "#FAFAFA",
    stroke: "#999999",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4153 55.3339C37.8386 50.9534 40.9222 46.9348 45.3027 46.3581L79.3584 41.8746C83.7389 41.2979 87.7575 44.3815 88.3342 48.762L89.3894 56.7767L39.4705 63.3487L38.4153 55.3339Z",
    fill: "#EEEEEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 98.1445,
    y: 42.9277,
    width: 2.0979,
    height: 6.99301,
    rx: 1.04895,
    transform: "rotate(82.5 98.1445 42.9277)",
    fill: "#999999"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 78.9844,
    y: 31.3438,
    width: 2.0979,
    height: 6.99301,
    rx: 1.04895,
    transform: "rotate(-7.5 78.9844 31.3438)",
    fill: "#999999"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 91.2773,
    y: 33.252,
    width: 2.0979,
    height: 6.99301,
    rx: 1.04895,
    transform: "rotate(37.5 91.2773 33.252)",
    fill: "#999999"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44.6875,
    y: 65.4834,
    width: 40.5594,
    height: 2.7972,
    rx: 1.3986,
    transform: "rotate(-7.5 44.6875 65.4834)",
    fill: "#DCDCDC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5117,
    y: 79.3496,
    width: 40.5594,
    height: 2.7972,
    rx: 1.3986,
    transform: "rotate(-7.5 46.5117 79.3496)",
    fill: "#DCDCDC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 48.3398,
    y: 93.2158,
    width: 40.5594,
    height: 2.7972,
    rx: 1.3986,
    transform: "rotate(-7.5 48.3398 93.2158)",
    fill: "#DCDCDC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 45.418,
    y: 71.0303,
    width: 14.6853,
    height: 2.7972,
    rx: 1.3986,
    transform: "rotate(-7.5 45.418 71.0303)",
    fill: "#EEEEEE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 47.2422,
    y: 84.8965,
    width: 14.6853,
    height: 2.7972,
    rx: 1.3986,
    transform: "rotate(-7.5 47.2422 84.8965)",
    fill: "#EEEEEE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 49.0664,
    y: 98.7627,
    width: 14.6853,
    height: 2.7972,
    rx: 1.3986,
    transform: "rotate(-7.5 49.0664 98.7627)",
    fill: "#EEEEEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotes);
export default __webpack_public_path__ + "static/media/noNotes.7934cf0c.svg";
export { ForwardRef as ReactComponent };